import { INCOME_MODULES } from '../../lib/incomeExpenseDefaults';

// The editor's starting state, built from the shop's own price list and profile.
//   services  [{ name, price, category }]   exactly what the Settings income card shows (category set = an "auto" module)
//   shop      { name, phone, address, qrUrl }
// Nothing here is saved anywhere: the poster starts fresh from the shop's data every time it opens.

export const RAIL = ['tpl', 'des', 'svc', 'shop'];
export const TEXT_KEYS = ['kicker', 'title', 'subtitle', 'note']; // words that have a Bangla and an English version

const MODULE_NAME_BN = new Map(INCOME_MODULES.map((m) => [m.category, m.name]));

/** The two names a service has on the poster. A built-in module gets its proper English name, unless the shop renamed it. */
function namesOf(service, tEn) {
    const bn = service.name;
    if (service.category && MODULE_NAME_BN.get(service.category) === service.name) {
        return { bn, en: tEn(`rateChart.modules.${service.category}`) };
    }
    return { bn, en: bn };
}

export function buildInitialState({ services, shop, lang, tBn, tEn, year }) {
    const both = (key) => ({ bn: tBn(key), en: tEn(key) });
    return {
        theme: 'teal', layout: 'banner', density: 1, cols: 1, paper: 'A4', lang,
        items: services.map((sv, i) => ({
            id: `s${i}`,
            category: sv.category || null,
            names: namesOf(sv, tEn),
            price: sv.price == null ? '' : String(sv.price),
            custom: false,
        })),
        off: {},
        texts: {
            kicker: both('rateChart.poster.kicker'),
            title: both('rateChart.poster.title'),
            subtitle: both('rateChart.poster.subtitle'),
            note: both('rateChart.poster.note'),
        },
        shop: shop.name || '',
        phone: shop.phone || '',
        addr: shop.address || '',
        year: String(year),
        logoSrc: '',
        qr: Boolean(shop.qrUrl),
        qrUrl: shop.qrUrl || '',
        showYear: true,
        wm: false,
    };
}
